<div class="simple-modal">
  <h1 class="simple-modal__title">{{ data.title }}</h1>
  <div class="simple-modal__content">{{ data.content }}</div>
  <div class="simple-modal__actions">
    <div class="simple-modal__actions__button">
      <ui-button
        (handleClick)="closeModal($event)"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="simple-modal-close"
        buttonText="Close"
        gtmTag="simple-modal-close"
      ></ui-button>
    </div>
  </div>
</div>
